import { render } from "./ConnectionRequestsTable.vue?vue&type=template&id=7ba4a8b6&scoped=true"
import script from "./ConnectionRequestsTable.vue?vue&type=script&lang=js"
export * from "./ConnectionRequestsTable.vue?vue&type=script&lang=js"

import "./ConnectionRequestsTable.vue?vue&type=style&index=0&id=7ba4a8b6&scoped=true&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba4a8b6"]])

export default __exports__